<template>
  <div class="wrap">

  </div>

</template>

<script>
    import $ from "jquery";

    export default {
      name: "FoundWinnersDetails",
      data(){
        return{
          stock:{
            name:'',
            //股票代码
            code:'',
            //最新价
            trade:'',
            //涨跌额
            pricechange:'',
            //涨跌幅
            changepercent:'',
            //成交量
            volume:'',
            //成交额
            amount:'',
            //时间
            time:'',
            //今开
            open:'',
            //昨收
            settlement:'',
            //最高
            high:'',
            //最低
            low:'',
            //换手
            hands:'',
            //市盈
            profit:'',
            //振幅
            amplitude:''
          },
          code:''
        }
      },
      methods:{
        getCode(){
          let that = this;
          that.code = that.$route.query.code.toLowerCase();
          that.getNewPrice(that.code);
        },


        getNewPrice(stockCode) {
          let that = this;
          $.ajax({
            url: "https://qt.gtimg.cn/q=" + stockCode,
            type: "GET",
            dataType: "script",
            cache: true,
            success: function() {
              var elements = eval("v_" + stockCode).split("~");
              that.stock.name = elements[1];
              that.stock.code = elements[2];
              that.stock.trade = elements[3];
              that.stock.pricechange = elements[31];
              that.stock.changepercent = elements[32];
              that.stock.volume = elements[36];
              that.stock.amount = elements[37];
              that.stock.time = elements[30];
              that.stock.open = elements[5];
              that.stock.settlement = elements[4];
              that.stock.high = elements[41];
              that.stock.low = elements[42];
              that.stock.hands = elements[38];
              that.stock.profit = elements[39];
              that.stock.amplitude = elements[43];
            }
          });
        },
      },
      mounted(){
        let that = this;
        that.getCode();
      }
    }
</script>

<style scoped>
  .wrap{
    background: url("https://sbpz.oss-accelerate.aliyuncs.com/front/FoundWinnersDetails.png");
    width: 100%;
    height: 1729px;
    background-size: cover;
    overflow: hidden;
    background-position: center center;
  }
  .hq_title{
    height: 30px;
  }
  .hq_title h4{
    float: left;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
  }
  .hq_title p{
    float: left;
    line-height: 30px;
    padding-left: 20px;
  }
  .hq_details li{
    float: left;
    padding-left: 20px;
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/FoundWinnersDetails.vue